import { IRowValidation } from '../../types';

export const validationMessages = {
  VALIDATION: 'Field validation error',
  DUPLICATE: 'Link is a duplicate',
  OK: 'OK',
  ERROR: 'Errors found',
};

export const isValid = (messages: string[]) =>
  messages.length === 1 && messages[0] === validationMessages.OK;

export const hasError = (messages: string[]) =>
  messages.length >= 1 &&
  [validationMessages.ERROR, validationMessages.VALIDATION].includes(
    messages[0]
  );

export const isDuplicate = (messages: string[]) =>
  messages.length >= 1 && messages[0] === validationMessages.DUPLICATE;

export const countMessages = (validation: IRowValidation[]) => {
  const counts = {
    unvalidated: 0,
    duplicates: 0,
    errors: 0,
    ok: 0,
  };
  validation.forEach((row) => {
    if (row.messages.length === 0) {
      counts.unvalidated++;
      return;
    }
    if (row.messages.includes(validationMessages.DUPLICATE)) {
      counts.duplicates++;
      return;
    }
    if (
      row.messages.includes(validationMessages.ERROR) ||
      row.messages.includes(validationMessages.VALIDATION)
    ) {
      counts.errors++;
      return;
    }
    if (row.messages.includes(validationMessages.OK)) {
      counts.ok++;
      return;
    }
  });
  return counts;
};



// WEBPACK FOOTER //
// ./src/views/LinkCreateBulk/components/services/validationMessages.ts